/**
 * 常量
 */
import { imgArr } from '../assets/images/img';
// 支付方式
export const PAY_WAY = [
    { label: '医保卡', value: '1', disabled: false, icon: '' },
    { label: '现金', value: '2', disabled: false, icon: imgArr.cash },
    { label: '好码齐', value: '3', disabled: false, icon: imgArr.haomuch },
    { label: '微信', value: '4', disabled: false, icon: imgArr.wechat },
    { label: '支付宝', value: '5', disabled: false, icon: imgArr.alipay },
    { label: '银行卡', value: '6', disabled: false, icon: imgArr.crad },
]

// 中药类型
export const DRUG_TYPE = [
        { label: '全部', value: '', disabled: true },
        { label: '饮片', value: '0', disabled: false },
        { label: '颗粒', value: '1', disabled: false },
    ]
    // 关系类型
export const relationOption = [
        { label: '父母', value: '1' },
        { label: '配偶', value: '2' },
        { label: '子女', value: '3' },
        { label: '兄弟姐妹', value: '4' },
        { label: '祖父母', value: '5' },
        { label: '外祖父母', value: '6' },
        { label: '孙子女', value: '7' },
        { label: '外孙子女', value: '8' },
    ]
    //药品煎法
export const handlingOptionsOld = ['包煎', '冲服', '打粉冲服', '另包', '烊化', '另煎', '同煎', '捣碎', '先炒', '打粉', '泡饮'];
export const handlingOptions = [
    { label: '先熬', description: '', value: '先熬' },
    { label: '先熬', description: '30分钟', value: '先熬30分钟' },
    { label: '先熬', description: '60分钟', value: '先熬60分钟' },
    { label: '先熬', description: '90分钟', value: '先熬90分钟' },
    { label: '后下', description: '', value: '后下' },
    { label: '后下', description: '5分钟', value: '后下5分钟' },
    { label: '后下', description: '10分钟', value: '后下10分钟' },
    { label: '后下', description: '15分钟', value: '后下15分钟' },
    { label: '包煎', description: '', value: '包煎' },
    { label: '冲服', description: '', value: '冲服' },
    { label: '打粉冲服', description: '', value: '打粉冲服' },
    { label: '另包', description: '', value: '另包' },
    { label: '烊化', description: '', value: '烊化' },
    { label: '另煎', description: '', value: '另煎' },
    { label: '同煎', description: '', value: '同煎' },
    { label: '捣碎', description: '', value: '捣碎' },
    { label: '先炒', description: '', value: '先炒' },
    { label: '打粉', description: '', value: '打粉' },
    { label: '泡饮', description: '', value: '泡饮' }
];

//剂量列表
export const doseOptions = ["1日1剂", "2日1剂", "1日半1剂", "1日2剂", "3日1剂", "3日2剂"]

// 备注
export const remarkOptions = [
        "饭前服用", "饭后服用", "空腹服用", "睡前服用",
        "调和送服", "定时服用", "少量频服", "随时服用", '外用'
    ]
    // 使用方式
export const drugMethodOptions = [
        "煎服", "冲服", "制膏", "制丸", "外用",
        "贴敷", "打粉", "泡饮", "泡酒", "泡浴", "泡脚", "擦拭"
    ]
    // 服用频次
export const frequencyOptions = [
        "1日1次", "1日2次", "1日3次", "1日4次", "1日5次", "1日6次", "2日1次", "隔日1次",
        "1周1次", "1周2次", "1周3次", "隔周1次", "必要时", "顿服", "少量频服", "随时服用"
    ]
    // 服用量
export const takingDosageOptions = ["每次10ml", "每次20ml", "每次30ml", "每次40ml", "每次50ml", "每次60ml", "每次70ml", "每次80ml", "每次90ml", "每次100ml", "每次120ml", "每次150ml", "每次180ml", "每次200ml", "每次250ml", "每次300ml"]

// 加工方式
export const processingOptions = ['熬药', '制膏', '蜜丸', '水丸', '粗粉', '细粉'];
//服用多少天
export const takeDaysOptions = ['服用10天', '服用15天', '服用20天', '服用25天', '服用1月', '服用35天', '服用40天', '服用45天', '服用50天', '服用2月', '服用3月', '服用4月', ]
    //贴敷时间
export const applicationTimeOptions = ['约敷5分钟', '约敷15分钟', '约敷半小时', '约敷45分钟', '约敷1小时', ]
    //泡浴时间
export const soakTimeOptions = ['约泡20分钟', '约泡40分钟', '约泡1小时', ]
    //打粉每次服用好多g
export const takeAmountFOptions = ['每次3g', '每次4g', '每次5g', '每次6g', '每次7g', '每次8g', '每次9g', '每次10g', '每次11g', '每次12g', '每次13g', '每次14g', '每次15g', '适量']
    //制膏每次服用多少
export const takeAmountGOptions = ['每次5g', '每次10g', '每次15g', '每次20g', '每次25g', '每次30g', '每次35g', '每次40g', '1汤匙', '2汤匙', '3汤匙', '适量']
    //制丸每次服用多少
export const takeAmountWOptions = ['每次3g', '每次6g', '每次9g', '每次10g', '每次12g', '每次15g', '1丸', '2丸', '5丸', '10丸', '20丸', '30丸', '适量']
    //角色
export const roleList = [
    { roleKey: 'qq', name: '后台' },
    { roleKey: '治疗师', name: '治疗师' },
    { roleKey: 'Formula', name: '配方员' },
    { roleKey: 'Doctor', name: '医生' },
    { roleKey: 'Charge', name: '收费员' },
    { roleKey: 'Register', name: '挂号员' },
    { roleKey: 'admin', name: '超级管理员' },
]


//状态列表
export const statusList = [
    { label: '超时', value: '-5' },
    { label: '跑单', value: '-4' },
    { label: '挂号退费', value: '-3' },
    { label: '停诊', value: '-2' },
    { label: '挂号取消', value: '-1' },
    { label: '未支付', value: '0' },
    { label: '待签到', value: '1' },
    { label: '待就诊', value: '2' },
    { label: '已就诊', value: '3' },
    { label: '已收费', value: '4' },
    { label: '正在看诊', value: '5' },
    { label: '已完成', value: '6' },
    { label: '叫号列表', value: '7' },
]

//药品类别
export const ybCenterDrugDirectoryCategorySignList = [
        { label: '甲类', value: '01' },
        { label: '乙类', value: '02' },
    ]
    //支付状态
export const orderStatus = [
    { id: -2, name: '退款' },
    { id: -1, name: '支付超时' },
    { id: 0, name: '待支付' },
    { id: 1, name: '待接诊' },
    { id: 2, name: '接诊中' },
    { id: 3, name: '已结束' },
    { id: 4, name: '接诊中' },
]

//网诊赠送时间列表
export const giftTimeList = [
        { id: 1, time: 15, label: '15分钟' },
        { id: 2, time: 30, label: '30分钟' },
        { id: 3, time: 45, label: '45分钟' },
        { id: 4, time: 60, label: '1小时' },
        { id: 5, time: 120, label: '2小时' },
        { id: 6, time: 180, label: '3小时' },
        { id: 7, time: 360, label: '6小时' },
        { id: 8, time: 720, label: '12小时' },
        { id: 9, time: 1440, label: '24小时' }
    ]
    //网诊状态
export const onlineStatus = [
        { id: -3, name: '取消', tag: 'infoTag' },
        { id: -2, name: '退号', tag: 'infoTag' },
        { id: -1, name: '超时', tag: 'infoTag' },
        { id: 0, name: '待支付', tag: 'infoTag' },
        { id: 1, name: '待诊', tag: 'parTag' },
        { id: 2, name: '已诊', tag: 'parTag' },
        { id: 3, name: '结束', tag: 'infoTag' },
        { id: 4, name: '就诊中', tag: 'parTag' },
    ]
    //门诊单患者列表状态
export const outpatientStatus = [
        { id: -6, name: '草稿', tag: 'succTag' },
        { id: 2, name: '待诊', tag: 'parTag' },
        { id: 3, name: '已诊', tag: 'infoTag' },
        { id: 4, name: '已收', tag: 'infoTag' },
        { id: 8, name: '待收', tag: 'infoTag' },
        { id: -7, name: '已退', tag: 'infoTag' },
        { id: 9, name: '关闭', tag: 'infoTag' },
    ]
    //用法不同展示联动的字段
export const doseCanChoose = [
    { name: '煎服', label: ['doseOptions', 'remarkOptions', 'frequencyOptions', 'takingDosageOptions'] },
    { name: '冲服', label: ['doseOptions', 'remarkOptions', 'frequencyOptions', 'bag'] },
    { name: '制膏', label: ['remarkOptions', 'frequencyOptions', 'takeDaysOptions', 'takeAmountGOptions'] },
    { name: '制丸', label: ['remarkOptions', 'frequencyOptions', 'takeDaysOptions', 'takeAmountWOptions'] },
    { name: '外用', label: ['frequencyOptions'] },
    { name: '贴敷', label: ['frequencyOptions', 'applicationTimeOptions'] },
    { name: '打粉', label: ['takeDaysOptions', 'remarkOptions', 'frequencyOptions', 'takeAmountFOptions'] },
    { name: '泡饮', label: ['doseOptions', 'remarkOptions', 'frequencyOptions', 'takingDosageOptions'] },
    { name: '泡酒', label: ['remarkOptions', 'frequencyOptions', 'takingDosageOptions', 'takeDaysOptions'] },
    { name: '泡浴', label: ['doseOptions', 'frequencyOptions', 'soakTimeOptions'] },
    { name: '泡脚', label: ['doseOptions', 'frequencyOptions', 'soakTimeOptions'] },
    { name: '擦拭', label: ['doseOptions', 'frequencyOptions', 'soakTimeOptions'] },
]

//初诊复诊
export const doctorVisitList = [
    { label: '初诊', value: '0' },
    { label: '复诊', value: '1' },
]

//初诊还是复诊
export const doctorVisitDict = {
    '0': '初诊',
    '1': '复诊'
}

//性别
export const sexDict = [
    { label: '男', value: '0' },
    { label: '女', value: '1' },
]

//门诊类型
export const outpatientTypeList = [
    { label: '普通门诊', value: '0' },
    { label: '普通门诊加号', value: '1' },
    { label: '特约门诊', value: '2' },
    { label: '特约门诊加号', value: '3' },
    { label: '理疗门诊', value: '4' },
    { label: '理疗门诊加号', value: '6' },
    { label: '义诊', value: '5' },
    { label: '义诊加号', value: '7' },
    { label: '补录挂号', value: '8' }, //门诊补录
    { label: '补录挂号', value: '9' }, //划价补录
    { label: '转方挂号', value: '10' }, //划价补录
    { label: '转方挂号加号', value: '11' }, //划价补录
]

//挂号状态列表
export const registerStatusList = [
    { label: '已约', value: "123", numLabel: '', amountLabel: '', num: null, bgImg: imgArr.statusBg1, fontColor: '#FE8F1F', bgColor: '#FFF9F3' },
    { label: '待签', value: "1", numLabel: 'staySignNum', amountLabel: 'staySignAmount', num: null, bgImg: imgArr.statusBg1, fontColor: '#FE8F1F', bgColor: '#FFF9F3' },
    { label: '已签', value: "23", numLabel: '', amountLabel: '', num: null, bgImg: imgArr.statusBg3, fontColor: '#667182', bgColor: '#F3FAFF' },
    { label: '待诊', value: "2", numLabel: 'staySeeNum', amountLabel: 'staySeeAmount', num: null, bgImg: imgArr.statusBg3, fontColor: '#2363DE', bgColor: '#F3FAFF' },
    { label: '已诊', value: "3", numLabel: 'alreadySeeNum', amountLabel: 'alreadySeeAmount', num: null, bgImg: imgArr.statusBg1, fontColor: '#667182', bgColor: '#FFF9F3' },
    { label: '退号', value: "-3", numLabel: 'refundNum', amountLabel: 'refundAmount', num: null, bgImg: imgArr.statusBg3, fontColor: '#667182', bgColor: '#F3FAFF' },
    { label: '停诊', value: "-2", numLabel: 'suspendNum', amountLabel: 'suspendAmount', num: null, bgImg: imgArr.statusBg2, fontColor: '#F54A45', bgColor: '#FFF5F4' },
    { label: '待付', value: "0", numLabel: 'stayPayNum', amountLabel: 'stayPayAmount', num: null, bgImg: imgArr.statusBg1, fontColor: '#FE8F1F', bgColor: '#FFF9F3' },
    { label: '取消', value: "-1", numLabel: 'cancelNum', amountLabel: 'cancelAmount', num: null, bgImg: imgArr.statusBg3, fontColor: '#667182', bgColor: '#F3FAFF' },
]

//门店对应编号
export const ybPhyCodeList = [
    { deptId: 1, deptName: '省医馆', code: 'H51010503998', name: '成都杏林春堂中医门诊部有限公司' },
    { deptId: 116, deptName: '华西馆', code: 'H51010705034', name: '成都武侯胡记中医门诊部' },
    { deptId: 117, deptName: '青羊馆', code: 'H51010503984', name: '成都青羊杏林明德中医诊所' },
    { deptId: 118, deptName: '东大馆', code: 'H51010400682', name: '成都锦江杏林诊所' },
    { deptId: 119, deptName: '紫荆馆', code: 'H51019900915', name: '成都高新杏林春堂中医门诊部' },
    { deptId: 120, deptName: '南充馆', code: 'H51130200923', name: '胡记春堂中医诊所' },
    { deptId: 121, deptName: '温江馆', code: 'H51011504325', name: '成都温江杏林德善中西医结合门诊部' },
    { deptId: 125, deptName: '万象馆', code: 'H51010801213', name: '成都成华维康达诊所有限公司' },
    { deptId: 123, deptName: '温江馆', code: 'H51010508333', name: '成都青羊杏林德鑫中医诊所有限公司' },
]

//班次类型 1上午2中午3下午4晚上5全天
export const schedulingTypeList = [
    { label: '上午', value: '1' },
    { label: '中午', value: '2' },
    { label: '下午', value: '3' },
    { label: '晚上', value: '4' },
    { label: '全天', value: '5' },
]
export const doseCanChooseKeys = ['doseFrequency', 'frequency', 'takingDosage', 'recipeMoment', 'mixingBagNum', 'creamDosage', 'takingDays', 'pelletizingDosage', 'applicationTime', 'bakingPowderDosage', 'wrapTime']
export const doseCanChooseList = [{
        name: '煎服',
        label: [
            { id: 'doseFrequency', name: '剂量', kid: doseOptions, allowInput: false, required: true, default: '1日1剂', width: '95px' },
            { id: 'frequency', name: '频率', kid: frequencyOptions, allowInput: true, required: false, default: '1日3次', width: '90px' },
            { id: 'takingDosage', name: '服用量', kid: takingDosageOptions, allowInput: true, required: true, default: '每次180ml', width: '100px' },
            { id: 'recipeMoment', name: '服用时间', kid: remarkOptions, allowInput: true, required: false, default: '', width: '90px' }
        ]
    },
    {
        name: '冲服',
        label: [
            { id: 'doseFrequency', name: '剂量', kid: doseOptions, allowInput: false, required: true, default: '1日1剂', width: '95px' },
            { id: 'frequency', name: '频率', kid: frequencyOptions, allowInput: true, required: false, default: '1日3次', width: '90px' },
            { id: 'mixingBagNum', name: '服用量', allowInput: true, required: false, default: 1 },
            { id: 'recipeMoment', name: '服用时间', kid: remarkOptions, allowInput: true, required: false, default: '', width: '90px' }
        ]
    },
    {
        name: '制膏',
        label: [
            { id: 'frequency', name: '频率', kid: frequencyOptions, allowInput: true, required: false, default: '1日3次', width: '90px' },
            { id: 'creamDosage', name: '服用量', kid: takeAmountGOptions, allowInput: true, required: false, default: '', width: '85px' },
            { id: 'takingDays', name: '服用天数', kid: takeDaysOptions, allowInput: false, required: false, default: '', width: '90px' },
            { id: 'recipeMoment', name: '服用时间', kid: remarkOptions, allowInput: true, required: false, default: '', width: '90px' }
        ]
    },
    {
        name: '制丸',
        label: [
            { id: 'frequency', name: '频率', kid: frequencyOptions, allowInput: true, required: false, default: '1日3次', width: '90px' },
            { id: 'pelletizingDosage', name: '服用量', kid: takeAmountWOptions, allowInput: true, required: false, default: '', width: '85px' },
            { id: 'takingDays', name: '服用天数', kid: takeDaysOptions, allowInput: false, required: false, default: '', width: '90px' },
            { id: 'recipeMoment', name: '服用时间', kid: remarkOptions, allowInput: true, required: false, default: '', width: '90px' }
        ]
    },
    {
        name: '外用',
        label: [
            { id: 'doseFrequency', name: '剂量', kid: doseOptions, allowInput: false, required: true, default: '1日1剂', width: '95px' },
            { id: 'frequency', name: '频率', kid: frequencyOptions, allowInput: true, required: false, default: '1日3次', width: '90px' }
        ]
    },
    {
        name: '贴敷',
        label: [
            { id: 'doseFrequency', name: '剂量', kid: doseOptions, allowInput: false, required: true, default: '1日1剂', width: '95px' },
            { id: 'frequency', name: '频率', kid: frequencyOptions, allowInput: true, required: false, default: '1日3次', width: '90px' },
            { id: 'applicationTime', name: '使用时长', kid: applicationTimeOptions, allowInput: true, required: false, default: '', width: '105px' }
        ]
    },
    {
        name: '打粉',
        label: [
            { id: 'frequency', name: '频率', kid: frequencyOptions, allowInput: true, required: false, default: '1日3次', width: '90px' },
            { id: 'bakingPowderDosage', name: '服用量', kid: takeAmountFOptions, allowInput: true, required: false, default: '', width: '85px' },
            { id: 'takingDays', name: '服用天数', kid: takeDaysOptions, allowInput: false, required: false, default: '', width: '90px' },
            { id: 'recipeMoment', name: '服用时间', kid: remarkOptions, allowInput: true, required: false, default: '', width: '90px' }
        ]
    },
    {
        name: '泡饮',
        label: [
            { id: 'doseFrequency', name: '剂量', kid: doseOptions, allowInput: false, required: true, default: '1日1剂', width: '95px' },
            { id: 'frequency', name: '频率', kid: frequencyOptions, allowInput: true, required: false, default: '1日3次', width: '90px' },
            { id: 'takingDosage', name: '服用量', kid: takingDosageOptions, allowInput: true, required: false, default: '', width: '100px' },
            { id: 'recipeMoment', name: '服用时间', kid: remarkOptions, allowInput: true, required: false, default: '', width: '90px' }
        ]
    },
    {
        name: '泡酒',
        label: [
            { id: 'frequency', name: '频率', kid: frequencyOptions, allowInput: true, required: false, default: '1日3次', width: '90px' },
            { id: 'takingDosage', name: '服用量', kid: takingDosageOptions, allowInput: true, required: false, default: '', width: '100px' },
            { id: 'recipeMoment', name: '服用时间', kid: remarkOptions, allowInput: true, required: false, default: '', width: '90px' }
        ]
    },
    {
        name: '泡浴',
        label: [
            { id: 'doseFrequency', name: '剂量', kid: doseOptions, allowInput: false, required: true, default: '1日1剂', width: '95px' },
            { id: 'frequency', name: '频率', kid: frequencyOptions, allowInput: true, required: false, default: '1日3次', width: '90px' },
            { id: 'wrapTime', name: '使用时长', kid: soakTimeOptions, allowInput: true, required: false, default: '', width: '105px' }
        ]
    },
    {
        name: '泡脚',
        label: [
            { id: 'doseFrequency', name: '剂量', kid: doseOptions, allowInput: false, required: true, default: '1日1剂', width: '95px' },
            { id: 'frequency', name: '频率', kid: frequencyOptions, allowInput: true, required: false, default: '1日3次', width: '90px' },
            { id: 'wrapTime', name: '使用时长', kid: soakTimeOptions, allowInput: true, required: false, default: '', width: '105px' }
        ]
    },
    {
        name: '擦拭',
        label: [
            { id: 'doseFrequency', name: '剂量', kid: doseOptions, allowInput: false, required: true, default: '1日1剂', width: '95px' },
            { id: 'frequency', name: '频率', kid: frequencyOptions, allowInput: true, required: false, default: '1日3次', width: '90px' }
        ]
    }
]

//门诊类型
export const outpatientTypeAbbrList = [
    { label: '普通', value: '0' },
    { label: '普通加号', value: '1' },
    { label: '特约', value: '2' },
    { label: '特约加号', value: '3' },
    { label: '理疗', value: '4' },
    { label: '理疗加号', value: '6' },
    { label: '义诊', value: '5' },
    { label: '义诊加号', value: '7' },
    { label: '补录挂号', value: '8' }, //门诊补录
    { label: '补录挂号', value: '9' }, //划价补录
    { label: '转方', value: '10' }, 
    { label: '转方加号', value: '11' }, 
]

//收费状态列表
export const chargeStatusList = [
    { label: '已诊', value: "6", fontColor: '#29C01B', bgColor: '#E2F8E0' },
    { label: '草稿', value: "-6", fontColor: '#29C01B', bgColor: '#E2F8E0' },
    { label: '待诊', value: "2", fontColor: '#1890FF', bgColor: '#E8F4FF' },
    { label: '已收', value: "4", fontColor: '#667182', bgColor: '#F0F1F3' },
    { label: '待收', value: "8", fontColor: '#FE8F1F', bgColor: '#FFF0E1' },
    { label: '已退', value: "-7", fontColor: '#667182', bgColor: '#F0F1F3' },
    { label: '关闭', value: "9", fontColor: '#667182', bgColor: '#F0F1F3' },
    { label: '跑单', value: "-4", fontColor: '#667182', bgColor: '#F0F1F3' },
    { label: '待审', value: "11", fontColor: '#1890FF', bgColor: '#E8F4FF' },
    { label: '已拒', value: "15", fontColor: '#667182', bgColor: '#F0F1F3' },
]

//退款状态
export const refundStatusList = [
    { label: '待退', value: '1' },
    { label: '退款中', value: '3' },
    { label: '退款完成', value: '5' },
    { label: '退款取消', value: '6' },
    { label: '退款失败', value: '7' },
]

//理疗执行状态
export const physioStatusList = [
        { label: '已结束', value: "0", fontColor: '#667182', bgColor: '#F0F1F3' },
        { label: '待执行', value: "1", fontColor: '#FE8F1F', bgColor: '#FFF0E1' },
    ]
    //理疗项目
export const propertyStatusList = [
    { value: '0', label: '待执行', fontColor: '#FE8F1F' },
    { value: '1', label: '已结束', fontColor: '#667182' },
    { value: '2', label: '已作废', fontColor: '#667182' },
]

//部位列表
export const partsList = [
        { label: '头面', children: ['鼻部', '耳部', '颞部', '前额部', '头顶部', '枕后部', '下颌部'] },
        { label: '颈肩', children: ['颈椎', '项部', '枕下部', '咽喉部', '颈前部', '颈外侧区', '颈根部', '肩前部', '肩袖部', '肩后部'] },
        { label: '胸腹', children: ['胸骨部', '胸上段', '胸中段', '胸下段', '胸外侧区', '乳房外上象限', '乳房外下象限', '乳房内上象限', '乳房内下象限', '乳晕乳头部', '上腹部', '中腹部', '下腹部', '侧腹部'] },
        { label: '腰背', children: ['肩胛区', '肩胛上区', '肩胛下区', '肩胛间区', '肩胛骨外缘', '腰上段', '腰中段', '腰下段', '腰骶部', '脊柱区'] },
        { label: '上肢', children: ['臂前区', '臂后区', '肘部', '前臂前区', '前臂后区', '手腕部', '手掌部', '小鱼际区', '大鱼际区', '手指部'] },
        { label: '下肢', children: ['臀部', '臀外侧部', '臀横纹区', '大腿前侧', '大腿后侧', '大腿内侧', '大腿外侧', '膝部', '小腿外侧', '小腿后侧', '小腿胫骨侧', '内踝', '外踝', '足背', '足底', '足趾'] },
    ]
    // 就诊来源类型
export const orderSourceTypeList = [
    { value: '0', label: '门诊' }, //挂号
    { value: '1', label: '门诊' }, //快捷开方
    { value: '2', label: '零售' },
    { value: '3', label: '续方' },
    { value: '5', label: '网诊' },
]

//配方单状态列表
export const formulaStatuaList = [
    { label: '已收费', value: "1", fontColor: '#29C01B' },
    { label: '已退药', value: "2", fontColor: '#FE8F1F' },
    { label: '已退费', value: "3", fontColor: '#667182' },
]

//配方单配方状态列表
export const recipeStatusList = [
    { label: '已处理', value: "1", fontColor: '#29C01B', backgroundColor: '#E2F8E0', icon: 'el-icon-success' },
    { label: '未处理', value: "0", fontColor: '#667182', backgroundColor: '#F2F2F2', icon: '' }
]

//分析系统链接
export const analysisSysUrl = {
    'warehousing': 'https://college.scxinglin.com/xl/ReportServer/v10/entry/access/fd16f466-ac44-444b-8c3a-e40f16b97a5b?preview=true', //商品入库
    'outbound': 'https://college.scxinglin.com/xl/ReportServer/v10/entry/access/19f7bd38-6659-4f79-8908-a92b6b8ed11a?preview=true', //商品出库
    'inventory': 'https://college.scxinglin.com/xl/ReportServer/v10/entry/access/b9ce5004-270a-4f6b-ac18-50a26516b54d?preview=true', //商品盘点
    'warehouseDetail': 'https://college.scxinglin.com/xl/ReportServer/v10/entry/access/694b3a2c-3b7f-4a82-9e01-2a71b65f5753?preview=true', //商品库存明细
    'supplierInfo': 'https://college.scxinglin.com/xl/ReportServer/v10/entry/access/795a2875-039e-40a9-9c74-ab7766f24f80?preview=true', //供应商资料
    'stockSummary': 'https://college.scxinglin.com/xl/ReportServer/v10/entry/access/b2c37740-d7b2-46fc-95a1-144d9d7c8bc1?preview=true' //进销存汇总
}

//医保属性
export const ybPropertyList = [
  { label: '可统筹',value: '2'},
  { label: '仅个账',value: '3'},
  { label: '不过医保',value: '1'},
  { label: '未选择',value: '4'},
]
export const couTypeList = [
  { label: '挂号券', value: '2' },
  { label: '药品券', value: '1' },
]

export const userType = [
  { label: '医生', value: '0' },
  { label: '医助', value: '1' },
  { label: '员工', value: '2' },
  { label: '其他', value: '3' },
]

export const productRechargeList = [{ id: 1, amt: 1000 },{ id: 2, amt: 3000 }, { id: 3, amt: 5000 }, { id: 4, amt: 10000 }]
export const testRechargeList = [{ id: 1, amt: 30 }, { id: 2, amt: 50 }, { id: 3, amt: 100 },{id:4,amt:300}]